import React from "react";
import OrderPills from "components/MainApp/atoms/Pills/OrderPills";
import { ParseDate, ParseDateTime } from "helpers/Parsers";

import styles from "./styles.module.scss";
import i18n from "i18n";
export const RequestOrderItemMobile = ({ requestOrder, handleClick }) => {
  return (
    <div
      className={styles["request-order-table-item-mobile-container"]}
      data-automation-id="request-order-table-item"
      data-requestorder-id={requestOrder.id}
      data-requestorder-type={requestOrder.type}
      onClick={handleClick}
    >
      <div className={styles["request-order-table-item-mobile-code"]}>
        Nro {requestOrder.code}
      </div>

      <div className={styles["request-order-table-item-mobile-date"]}>
        {i18n.t("date")}: {ParseDate(requestOrder.created_at)}
      </div>

      <div className={styles["request-order-table-item-mobile-bottom"]}>
        <div className={styles["request-order-table-item-mobile-owner"]}>
          {i18n.t("owner")[0].toUpperCase() + i18n.t("owner").substring(1)}:{" "}
          {requestOrder.owner
            ? `${requestOrder.owner.first_name} ${requestOrder.owner.last_name}`
            : "-"}
        </div>
        <div className={styles["request-order-table-item-mobile-state-inner"]}>
          <OrderPills state={requestOrder.status}></OrderPills>
        </div>
      </div>
    </div>
  );
};

export default RequestOrderItemMobile;
